import PropTypes from 'prop-types';
import React from 'react';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import {t} from 'i18next';
import ActionLink from '../../components/ActionLink';
import BaseUserListContainer from '../../baseContainers/BaseUserListContainer';
import EmployeeModel from '../../model/EmployeeModel';
import ReserveService from '../../services/ReserveService';
import moment from 'moment/moment';
import EmployeeCategoryService from '../../services/UserCategoryService';
import CriteriaMultiSelectComponent from '../../components/criteria/CriteriaMultiSelectComponent';
import IconColorComponent from '../../components/inputs/IconColorComponent';
import { Chip } from 'primereact/chip';
import ProjectService from '../../services/ProjectService';
import ProjectCategoryService from '../../services/ProjectCategoryService';

class EmployeeReserveSoonAbsentList extends BaseUserListContainer {
    constructor(props) {
        super(props, new ReserveService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusOptions: [],
            empCategories: [],
            dialogVisibile: false,
            element: new EmployeeModel(),
        };
        this.projectService=new ProjectService();
        this.projectCategoryService=new ProjectCategoryService();
        this.empCategoryService = new EmployeeCategoryService();
    }

    updateSearchCriteria(criteria) {
        let baseUpdateSearchCriteria = super.updateSearchCriteria(criteria);
        baseUpdateSearchCriteria.empCategories = criteria.empCategories;
        baseUpdateSearchCriteria.subcontractorName = '';
        const {urlParams}=this.props;
        if(urlParams.first){
            baseUpdateSearchCriteria.firstResult=urlParams.first;
            baseUpdateSearchCriteria.maxResults=urlParams.maxs;
        }
        return baseUpdateSearchCriteria;
    }

    getCleanSearchCriteria() {
        let baseSearchCriteria = super.getCleanSearchCriteria();
        baseSearchCriteria.empCategories = [];
        baseSearchCriteria.subcontractorName = '';
        baseSearchCriteria.sortField='absences.dateFrom';
        return baseSearchCriteria;
    }

      initializeFromBackend() {
        super.initializeFromBackend();
        
        this.projectCategoryService.getList({ firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true, status:{enumValue: 'ACTIVE' }})
            .then(categories => this.setState({ projectCategories: categories.content }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy kategorii');
            });
        this.empCategoryService.getList({ firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true, status:{enumValue: 'ACTIVE' } })
        .then(categories => this.setState({ empCategories: categories.content }))
        .catch(() => {
            this.showErrorMessage('Nie udało się pobrać listy kategorii');
        });

        this.enumService
        .getEnumList('ExpirationAlarmStatus')
        .then((data)=>{
            this.setState({
                expirationAlarmStatusOptions: data.filter((x)=>x?.enumValue!=='HANDLED')
            })
        }).catch((ex)=>{
            this.showErrorMessage('Nie udało się pobrać listy statusów dokumentów');
        });
    }

    getList() {
        const {criteria} = this.state;
        const activeElement = document.activeElement;
        this.setState(
            {
                loading: true,
            },
            () => {
                this.service
                    .getSoonAbsentList(criteria)
                    .then((data) => {
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: this.updateListElements(data.content),
                                    loading: false,
                                    summary: data?.summary,
                                    size: data.totalElements,
                                },
                                () => {
                                    this.onAfterGetList(data);
                                    this.setTimeout(() => activeElement?.focus(), 50);
                                }
                            );
                        }
                    })
                    .catch((err) => {
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: [],
                                    loading: false,
                                    size: 0,
                                },
                                () => {
                                    this.afterGetListError();
                                }
                            );
                        }
                    });
            }
        );
    }

    categoriesMultiSelectTemplate(category) {
        return category ? 
        <div style={{
            display: 'flex',
            justifyContent: 'start',
            gap: "20px",
            alignItems: 'center',
            alignContent: 'center',
            padding: '5px 0px 0px 0px'
        }}>
            <IconColorComponent
                componentClassName="col-1"
                fontSize={"22px"}
                icon={category.icon.value}
                color={category.color.value}
                tootltipText={category.name}
            />
            <span>
                {category.name}
            </span>
        </div>
        :
        null
    }

    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='email-sc'
                    name='email'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.email}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('employee.email')}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                <CriteriaTextComponent
                    id='firstName-sc'
                    name='firstName'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.firstName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('employee.firstName')}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                <CriteriaTextComponent
                    id='lastName-sc'
                    name='lastName'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.lastName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('employee.lastName')}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={t('employee.status')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.status}
                    options={this.state.statusOptions}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    filterOptionValue='label'
                    refreshFromBackend
                />
            <CriteriaDropdownComponent
                    id='status-sc'
                    name='expirationAlarmStatus'
                    showClear
                    label={t('employee.documentStatus')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.expirationAlarmStatus}
                    options={this.state.expirationAlarmStatusOptions}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    filterOptionValue='label'
                    refreshFromBackend
                />
                <CriteriaTextComponent
                    id='subcontractorName-sc'
                    name='subcontractorName'
                    showClear
                    label={t('employee.subcontractorName')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.subcontractorName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                <CriteriaMultiSelectComponent
                    id='categories'
                    name='projectCategories'
                    label={t('reserve.project.categories')}
                    colClass='col-md-4'
                    onChange={this.handleChangeSc}
                    options={this.state.projectCategories}
                    optionLabel='name'
                    value={this.state.criteria.projectCategories}                                            
                    dataKey='id' 
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                 <CriteriaMultiSelectComponent
                    id='categories'
                    name='empCategories'
                    label={t('reserve.employee.categories')}
                    colClass='col-md-4'
                    onChange={this.handleChangeSc}
                    options={this.state.empCategories}
                    optionLabel='name'
                    value={this.state.criteria.empCategories}                                            
                    dataKey='id' 
                    filter
                    filterBy='name'
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                    selectedItemTemplate={(category) => {
                        return this.categoriesMultiSelectTemplate(category)
                    }}
                    itemTemplate={(category) => {
                        return this.categoriesMultiSelectTemplate(category)
                    }}    
                />
            </div>
        );
    }


    actionTemplate(rowData) {
        const {detailUrl} = this.props;
        let detailHref = `${detailUrl}/${rowData?.id}`;
        if(this.props.urlParams){
            detailHref+='?backActiveIndex='+this.props.urlParams?.activeIndex;
        }
        if(detailHref.includes('?')){
            detailHref+='&first='+this.state.criteria.firstResult;
            detailHref+='&maxs='+this.state.criteria.maxResults;   
        }else{
            detailHref+='?first='+this.state.criteria.firstResult;
            detailHref+='&maxs='+this.state.criteria.maxResults;   
        }
        return (
            <div>
                <ActionLink
                    iconName='mdi-eye'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={this.handleGoToDetail.bind(this, detailHref)}
                    variant='blue'
                    className='edit-blue-link'
                    key={'view-button'}
                />
            </div>
        );
    }
    prepareHeaderItems() {        
    }

    inputColorTemplate(rowData){
        if(rowData?.categories)
        return <div className="row" >
              {rowData.categories.map(category=>{
                  return <IconColorComponent componentClassName="col-1" fontSize={"22px"} icon={category.icon.value} color={category.color.value} tootltipText={category.name} />
           })}
          </div>
      }
    absencesTemplate(rowData) {
        if (rowData?.absence) {
            let absence=rowData?.absence;
            return (
                <span className='absence-container'>
                    <span>
                        {`Od:  ${moment(absence?.dateFrom).format('YYYY-MM-DD')}`}
                    </span>
                    <span style={{ whiteSpace: 'pre-wrap' }}>
                        {`Do:  ${moment(absence?.dateTo).format('YYYY-MM-DD')}`}
                   </span>
                </span>
                );
        } else {
            return '';
        }
    }
    documentStatusTemplate(rowData){
        if(rowData?.statusModel){
        let documentStatus=rowData.statusModel;
        return documentStatus.status.enumValue ? (
            <div className='row' style={{ display: 'flex', justifyContent: 'center', width:'100px' }}>
                     {
                         <IconColorComponent componentClassName="col-1" fontSize={"22px"} icon={documentStatus.icon.value} color={documentStatus.color.value} tootltipText={documentStatus.name} />
                     }
                 </div>
             ) : null
         }
    }
    projectCategoryTemplate(rowData) {
        if (rowData?.assignedProject?.categories) {
            return (
                rowData.assignedProject.categories.map(c => {
                    return (
                        <Chip style={{backgroundColor:c?.color?.value, color:"black"}} label={c.name} />
                    )
                })
            )
        } else {
            return '';
        }
    }
    prepareColumns() {
        const result = [
            {field: 'assignedProject.name', header: t('reserve.project.name'), sortable: false},
            {field: 'assignedProject.categories', header: t('reserve.project.categories'), sortable: false, body: this.projectCategoryTemplate.bind(this)},
            {field: 'firstName', header: t('employee.firstName'), sortable: true},
            {field: 'lastName', header: t('employee.lastName'), sortable: true},
            {field: 'absences', header: t('employee.absence.columnLabel'), sortable: true, body: this.absencesTemplate.bind(this)},
            {field: 'categories', header: t('reserve.employee.categories'), sortable: false, body: this.inputColorTemplate.bind(this)},
            {field: 'subcontractor.name', header: t('employee.subcontractorName'), sortable: true},
            {field: 'status', header: t('employee.status'), sortable: true, body: this.enumTemplate.bind(this, 'status')},
            {field: 'statusModel', header: t('employee.documentStatus'), sortable: false, body: this.documentStatusTemplate.bind(this)}
        ];
        if (this.authService.isUserInRole('ROLE_USER_RESERVE_EDIT')) {
            result.push({
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action',
            })
        }
        return result;
    }


    render() {
        return (
            <div className='container-fluid'>
                <BreadcrumbsItem to='/reserve-ready-list'>{'Pracownicy gotowi do wyjazdu'}</BreadcrumbsItem>
                {this.renderView()}
            </div>
        );
    }
}

EmployeeReserveSoonAbsentList.defaultProps = {
    detailUrl: '#/reserve/employee/details',
    lazy: true,
};

EmployeeReserveSoonAbsentList.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default EmployeeReserveSoonAbsentList;